<template>
    <div @click="isOpen" class="absolute right-4 bottom-24">
        <span class="bg-red-900 border border-yellow-200 outline outline-amber-800 text-base p-2">
            <img class="inline" :src="'/common/flags/' + $page.props.locale + '.png'"> {{ $t("Language") }}
        </span>
        <div v-show="show" class="grid grid-flow-row text-center text-base absolute py-2 mt-2 bg-red-900 border border-yellow-200 outline outline-amber-800">
            <span v-for="(name, code) in config.locale" @click="changeLocale(code)">
                <img class="m-4" :src="'/common/flags/' + code + '.png'" width="20">
            </span>
        </div>
    </div>
</template>

<script setup>
import {computed, ref} from "vue";
import {usePage} from '@inertiajs/inertia-vue3'
import {Inertia} from "@inertiajs/inertia";
import {loadLanguageAsync} from "laravel-vue-i18n";

let show = ref(false);
const isOpen = () => (show.value = !show.value)

const config = computed(() => usePage().props.value.config)

function changeLocale(code) {
    Inertia.get(route('set_locale', {locale: code}), {}, {
        preserveScroll: true,
        onSuccess: () => loadLanguageAsync(code)
    });
}
</script>
